import { render } from "./blog-article-table.vue?vue&type=template&id=1ab16fda"
import script from "./blog-article-table.vue?vue&type=script&lang=js"
export * from "./blog-article-table.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__